import './styles/player-profile.css'

import { IoClose } from "react-icons/io5";
import { fontType, main } from "../assets/extras";

const PlayerProfile = ({ variables, setVariables, showMessage, saveEvent }) => {
    return (
        <div className='mainPlayersComponent' style={{
            opacity: variables.showPlayerProfile ? 1 : 0,
            zIndex: variables.showPlayerProfile ? 1 : -1000
        }}>
            <div style={{
                backgroundColor: "white",
                borderRadius: 20,
                boxShadow: "2px 2px 5px black",
                position: "relative",
                padding: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column"
            }} className="contEvents">
                <IoClose
                    size={24}
                    color="red"
                    style={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        cursor: "pointer"
                    }}
                    onClick={() => setVariables(prev => ({
                        ...prev,
                        showPlayerProfile: false
                    }))}
                />

                <div style={{
                    width: "100%",
                    height: "40%",
                    minHeight:250,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center"
                }}>
                    <h3 style={{
                        textAlign: "left",
                        width: "100%",
                        fontFamily: fontType.title,
                        fontSize: 25,
                        marginBottom: 10
                    }}>AGREGAR EVENTO</h3>
                    <div style={{
                        width: "80%"
                    }}>
                        <input placeholder="Nombre del evento"
                            style={{
                                width: "100%",
                                height: 35,
                                fontFamily: fontType.text,
                                paddingLeft: 20,
                                paddingRight: 20,
                                borderRadius: 10,
                                border: "2px solid #ccc",
                                marginBottom: 10,
                                outline: "none"
                            }}
                            onChange={e => {
                                const t = e.target.value

                                setVariables(prev => ({
                                    ...prev,
                                    newPlayerEvent: {
                                        ...prev.newPlayerEvent,
                                        nombre_evento: t
                                    }
                                }))
                            }}
                            maxLength={100}
                        />
                        <input placeholder="Comentarios"
                            style={{
                                width: "100%",
                                height: 35,
                                fontFamily: fontType.text,
                                paddingLeft: 20,
                                paddingRight: 20,
                                borderRadius: 10,
                                border: "2px solid #ccc",
                                marginBottom: 10,
                                outline: "none"
                            }}
                            onChange={e => {
                                const t = e.target.value

                                setVariables(prev => ({
                                    ...prev,
                                    newPlayerEvent: {
                                        ...prev.newPlayerEvent,
                                        comentarios_evento: t
                                    }
                                }))
                            }}
                            maxLength={200}
                        />

                        <p style={{
                            fontFamily: fontType.title,
                            fontSize: 15
                        }}>Seleccionar fecha:</p>
                        <input placeholder="Comentarios"
                            style={{
                                width: "100%",
                                height: 35,
                                fontFamily: fontType.text,
                                paddingLeft: 20,
                                paddingRight: 20,
                                borderRadius: 10,
                                border: "2px solid #ccc",
                                marginBottom: 10,
                                outline: "none"
                            }}
                            type="date"
                            onChange={e => {
                                const t = e.target.value

                                setVariables(prev => ({
                                    ...prev,
                                    newPlayerEvent: {
                                        ...prev.newPlayerEvent,
                                        fecha_evento: t
                                    }
                                }))
                            }}
                        />

                        <div style={{
                            display: "flex",
                            justifyContent: "end",
                            width: "100%"
                        }}>
                            <button style={{
                                padding: 10,
                                borderRadius: 5,
                                border: "none",
                                backgroundColor: main,
                                fontFamily: fontType.title,
                                fontSize: 16,
                                color: "white",
                                cursor: "pointer"
                            }} onClick={async () => {
                                const newEvent = variables.newPlayerEvent

                                if(newEvent.nombre_evento && newEvent.comentarios_evento && newEvent.fecha_evento){
                                    if(variables.data.eventos_jugador) {

                                        await saveEvent()

                                        setVariables(prev => ({
                                            ...prev,
                                            data: {
                                                ...prev.data,
                                                eventos_jugador: [{...newEvent}, ...prev.data.eventos_jugador,]
                                            },
                                            newPlayerEvent: {
                                                nombre_evento: "",
                                                comentarios_evento: "",
                                                fecha_evento: ""
                                            }
                                        }))
                                    } else {

                                        await saveEvent()

                                        setVariables(prev => ({
                                            ...prev,
                                            data: {
                                                ...prev.data,
                                                eventos_jugador: [{...newEvent}]
                                            },
                                            newPlayerEvent: {
                                                nombre_evento: "",
                                                comentarios_evento: "",
                                                fecha_evento: ""
                                            }
                                        }))
                                    }
                                } else {
                                    showMessage("Debes completar todos los campos", "warning")
                                }

                            }}>
                                AREGAR
                            </button>
                        </div>
                    </div>
                </div>
                <div style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: variables.data.eventos_jugador ? "unset" : "center",
                    overflowY: "scroll"
                }}>
                    {
                        variables.data.eventos_jugador ?
                            variables.data.eventos_jugador.length > 0 ?
                                variables.data.eventos_jugador.map((v, i) => {
                                    return (
                                        <div style={{
                                            marginBottom: 10,
                                            width: "90%",
                                            minWidth: 300,
                                            height: 100,
                                            border: "2px solid #ccc",
                                            padding: 10,
                                            borderRadius: 10,
                                            boxShadow: "2px 2px 5px #ccc",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-evenly"
                                        }}>
                                            <p style={{fontFamily: fontType.text}}><span style={{fontWeight: "bold"}}>Evento:</span> {v.nombre_evento}</p>
                                            <p style={{fontFamily: fontType.text}}><span style={{fontWeight: "bold"}}>Comentarios:</span> {v.comentarios_evento}</p>
                                            <p style={{fontFamily: fontType.text}}><span style={{fontWeight: "bold"}}>Fecha:</span> {v.fecha_evento}</p>
                                        </div>
                                    )
                                })
                            :
                                <p style={{
                                    fontFamily: fontType.text,
                                    fontSize: 14
                                }}>No hay eventos registrados aun</p>
                        :
                            <p style={{
                                fontFamily: fontType.text,
                                fontSize: 14
                            }}>No hay eventos registrados aun</p>
                            
                            
                    }
                </div>

            </div>
        </div>
    )
}

export default PlayerProfile